var map = {
	"./ubao-1.png": 9341,
	"./ubao-2.png": 5574,
	"./ubao-3.png": 671,
	"./ubao-4.png": 8448,
	"./ubao-base.png": 8917,
	"./ubao-bg.png": 875
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2281;